import { ShadcnButton, ShadcnForm } from '@shadcn-features/core';
import { useTranslation } from 'react-i18next';
import { Flex } from '@src/components/ui/flex';
import useLangText from '@shared/hooks/useLangText';
import { ServiceProcessButtonType, ServiceVM } from '@shared/types/process';

export const ServiceReject = ({
    btn,
    service,
    onResult,
}: {
    btn: ServiceProcessButtonType;
    service: ServiceVM;
    onResult: (value: { rejectServiceIds: string[] }) => void;
}) => {
    const { t } = useTranslation();
    const getLangText = useLangText();
    return (
        <>
            <ShadcnForm
                wrapper={{
                    wrapperType: 'modal',
                    container: false,
                    title: t('translation:reject'),
                    trigger: {
                        triggerType: 'button',
                        triggerText: getLangText(btn.name),
                        type: 'button',
                    },
                    submitter: {
                        submitText: t('translation:reject'),
                    },
                    closeOnFinish: true,
                    footer(submitterButton, other) {
                        return (
                            <Flex gap={10} justify='end'>
                                <ShadcnButton onClick={other.onClose}>
                                    {t('translation:cancel')}
                                </ShadcnButton>
                                {submitterButton}
                            </Flex>
                        );
                    },
                }}
                onFinish={onResult}
            >
                <ShadcnForm.MultiSelect
                    allowClear
                    label={t('translation:rejectService')}
                    mode='multiple'
                    name={'rejectServiceIds'}
                    rules={[{ required: true }]}
                    query={{
                        url: 'flow/FlowDictionaries/MyServices',
                        params: {
                            ServiceProcessId: service.rejectServiceProcessId,
                            stageId: service?.rejectStageId,
                        },
                        enabled: !!service.rejectServiceProcessId,
                    }}
                />
            </ShadcnForm>
        </>
    );
};
